import React from 'react';
import PropTypes from 'prop-types';
import './ValuePropsBanner.less';

const DEFAULT_DATA = [
  {
    link: '/faq/115002839971-does-zola-offer-free-shipping-',
    content: (
      <>
        <b>Free shipping</b>
        <br />
        and returns
      </>
    ),
  },
  {
    link: '/faq/115002838511-does-zola-offer-price-matching-what-is-zola-s-price-matching-policy-',
    content: (
      <>
        Guaranteed
        <br />
        <b>price matching</b>
      </>
    ),
  },
  {
    link: '/faq/115002837692-does-zola-offer-a-post-wedding-or-completion-discount-',
    content: (
      <>
        <b>20% off</b> after
        <br />
        your wedding
      </>
    ),
  },
];

const WEDDING_SHOP_DATA = [
  {
    link: '/faq/115002839971-does-zola-offer-free-shipping-',
    content: (
      <>
        <b>Free shipping</b>
        <br />
        and returns
      </>
    ),
  },
  {
    link: '/faq/115002838511-does-zola-offer-price-matching-what-is-zola-s-price-matching-policy-',
    content: (
      <>
        Guaranteed
        <br />
        <b>price matching</b>
      </>
    ),
  },
  {
    link: '/shop/brands/wedding-shop',
    content: (
      <>
        Today&apos;s <b>best</b>
        <br />
        wedding brands
      </>
    ),
  },
];

export default function ValuePropsBanner({ isWeddingBoutiquePage }) {
  const bannerItems = isWeddingBoutiquePage ? WEDDING_SHOP_DATA : DEFAULT_DATA;

  return (
    <div className="value-props-banner">
      {bannerItems.map((item, i) => (
        <a className="value-prop" key={i} href={item.link}>
          {item.content}
        </a>
      ))}
    </div>
  );
}

ValuePropsBanner.propTypes = {
  isWeddingBoutiquePage: PropTypes.bool,
};
